import {currencyUnit} from '../config/ConfigGeneral'
import {Modal} from 'antd'
import {trans} from './HelperGlobal'
import _ from 'lodash'

const {PhoneNumberUtil, PhoneNumberFormat} = require('google-libphonenumber');
const phoneUtil = PhoneNumberUtil.getInstance();
const PNF = PhoneNumberFormat;

const HelperGeneral = {
    alertMessage(data) {
        let message = ''

        if (data) {
            data = data.response ? data.response.data : data
            data = data.data ? data.data : data
        }

        if (data && data.Errors) {
            if (data.Errors.length > 0) {
                for (let result of data.Errors) {
                    message += result + '\n'
                }
            } else {
                message += data.Errors
            }
        } else if (data && data.Result) {
            message += data.Result
        } else if (data && data.message) {
            message += data.message
            if (message === 'Network request failed') {
                message = trans('t30')
            }
        } else if (data && data.Message) {
            message += data.Message
        } else if (data && data.message === null && data.code) {
            message += data.code
        } else if (data && Array.isArray(data)) {
            for (let result of data) {
                message += result + '\n'
            }
        } else if (data && typeof data !== 'object') {
            message += data
        } else {
            message = trans('t17')
        }
        return message
    },
    alert(data, type, title, clickPageChange = null, closeTime = 600000) {
        let modal = false
        let message = HelperGeneral.alertMessage(data)

        type = type ? type : 'error'
        if (type === 'success') {
            title = title ? title : trans('t8')
            modal = Modal.success({
                title: title,
                content: message,
                okText: trans('t7'),
                centered: true,
                maskStyle: {
                    backgroundColor: 'rgba(255, 255, 255, 0.80)',
                },
                onOk() {
                    if (clickPageChange) window.location.href = clickPageChange;
                }
            })
        } else if (type === 'error') {
            title = title ? title : trans('t5')
            modal = Modal.error({
                title: title,
                content: message,
                okText: trans('t7'),
                centered: true,
                maskStyle: {
                    backgroundColor: 'rgba(255, 255, 255, 0.80)',
                },
                onOk() {
                    if (clickPageChange) window.location.href = clickPageChange;
                }
            })
        } else if (type === 'info') {
            title = title ? title : trans('t6')
            modal = Modal.info({
                title: title,
                content: message,
                okText: trans('t7'),
                centered: true,
                maskStyle: {
                    backgroundColor: 'rgba(255, 255, 255, 0.80)',
                },
                onOk() {
                    if (clickPageChange) window.location.href = clickPageChange;
                }
            })
        } else if (type === 'warning') {
            title = title ? title : trans('t6')
            modal = Modal.warning({
                title: title,
                content: message,
                okText: trans('t7'),
                centered: true,
                maskStyle: {
                    backgroundColor: 'rgba(255, 255, 255, 0.80)',
                },
                onOk() {
                    if (clickPageChange) window.location.href = clickPageChange;
                }
            })
        }

        setTimeout(() => {
            if (modal) {
                modal.destroy()
            }
        }, closeTime)
    },
    replaceAll(str, find, replace) {
        return str.replace(new RegExp(find, 'g'), replace)
    },
    stringClear(str) {
        let result = HelperGeneral.replaceAll(str, '-', '')
        result = HelperGeneral.replaceAll(result, ' ', '')
        result = result.replace('(', '')
        result = result.replace(')', '')
        return result
    },
    strShort(str = '', length = null) {
        if (str && length !== null) {
            return (str.length > (length - 3)) ? str.substring(0, length) +
                '...' : str
        }
        return str
    },
    TurkishCharClear(value) {
        let Turkish = {
            Ç: 'C',
            Ö: 'O',
            Ş: 'S',
            İ: 'I',
            I: 'i',
            Ü: 'U',
            Ğ: 'G',
            ç: 'c',
            ö: 'o',
            ş: 's',
            ı: 'i',
            ü: 'u',
            ğ: 'g',
            i: 'i',
        }
        let clearTr = value.replace(/Ü|Ç|Ö|Ş|İ|I|Ğ|ç|ö|ş|ı|ü|ğ/gi,
            function (matched) {
                return Turkish[matched]
            })
        return clearTr
    },
    normalizeScannerQrInput(str) {
        if (typeof str !== 'string' || !str.trim()) return str;
        return str
            .replace(/Ç/gi, '.')
            .replace(/\*/g, '-');
    },
    extractQrcodeFromUrlOrRaw(str) {
        if (typeof str !== 'string' || !str.trim()) return null;
        const normalized = HelperGeneral.normalizeScannerQrInput(str.trim());
        const patternMatch = normalized.match(/(\d+)[\-*]([A-Za-z0-9]+)/i);
        if (patternMatch) {
            const full = patternMatch[1] + '-' + patternMatch[2];
            const code = patternMatch[2];
            return { full, code };
        }
        let path = normalized;
        try {
            const u = new URL(normalized);
            path = u.pathname;
        } catch (_e) {
            path = normalized;
        }
        const qrSegmentMatch = path.match(/[\/.]qr[\/.]([^\s\/]+)/i);
        if (qrSegmentMatch) {
            const segment = qrSegmentMatch[1].replace(/\*/g, '-');
            const parts = segment.split('-');
            const code = parts.length > 1 ? parts[parts.length - 1] : segment;
            return { full: segment, code };
        }
        return null;
    },

    formatMoneyTL(n) {
        return parseFloat(n).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1.').replace(/\.(\d+)$/, ',$1') + ' ' + currencyUnit
    },
    formatPoint(value) {
        if (value === null || value === undefined || value === '') return '0';
        const str = String(value).trim();
        if (str.includes(',')) return str.replace(/,00$/, '');
        return str.replace(/\.00$/, '');
    },
    formatNumber(num, brackets = '.') {
        num = num ? num : 0
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + brackets)
    },
    formatTelephone(text, type = 1, lang = 'TR') {
        if (text) {
            const number = phoneUtil.parseAndKeepRawInput(text, lang)
            if (type === 1) {
                return phoneUtil.format(number, PNF.E164)
            } else if (type === 2) {
                return phoneUtil.format(number, PNF.INTERNATIONAL)
            }
        } else {
            return ''
        }
    },
    isObject(v) {
        while (Object.prototype.toString.call(v) === '[object Object]') {
            if ((v = Object.getPrototypeOf(v)) === null) {
                return true
            }
        }
        return false
    },
    getExtension(text) {
        let re = /(?:\.([^.]+))?$/
        let result = (re.exec(text)[1]) ? (re.exec(text)[1]) : ''
        return result.toLowerCase()
    },
    trim(string) {
        return string.replace(/^\s+|\s+$/g, '')
    },
    json2array(json) {
        let result = []
        let keys = Object.keys(json)
        let values = Object.values(json)
        keys.forEach(function (key, i) {
            result[key] = values[i]
        })

        return result
    },
    getObjectKeyExists(data, value) {
        let found = Object.keys(data).filter(function (key) {
            return data[key] === value
        })
        if (found.length) {
            return false
        } else {
            return true
        }
    },
    bodyAddClass(bodyClassName, htmlClassName = '') {
        const body = document.getElementById('htmlMain')
        const bodyMain = document.querySelector('#htmlMain body')

        if (body && body.removeAttribute) {
            body.removeAttribute('class')
        }
        if (htmlClassName && body && body.classList) {
            body.classList.add(htmlClassName)
        }
        if (bodyMain && bodyMain.removeAttribute) {
            bodyMain.removeAttribute('class')
        }
        if (bodyClassName && bodyMain && bodyMain.classList) {
            bodyMain.classList.add('bg-purple')
        }
    },
    pageChange(thisSelf, changePage) {
        const history = thisSelf?.props?.history ?? thisSelf?.history;

        if (!changePage) return;

        if (history?.push) {
            history.push(changePage);
            return;
        }

        window.location.href = changePage;
    },
    getBase64(file) {
        return new Promise(resolve => {
            let baseURL = ''
            let reader = new FileReader()

            reader.readAsDataURL(file)
            reader.onload = () => {
                baseURL = reader.result
                resolve(baseURL)
            }
        })
    },
    toDataURL(src, outputFormat) {
        return new Promise(resolve => {
            const img = new Image()
            img.crossOrigin = 'Anonymous'
            img.onload = function () {
                const canvas = document.createElement('CANVAS')
                const ctx = canvas.getContext('2d')
                let dataURL
                canvas.height = this.naturalHeight
                canvas.width = this.naturalWidth
                ctx.drawImage(this, 0, 0)
                dataURL = canvas.toDataURL(outputFormat)
                resolve(dataURL)
            }
            img.src = src
            if (img.complete || img.complete === undefined) {
                img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=='
                img.src = src
            }
        })
    },
    telephoneClear(landPhone, type = 1) {
        landPhone = _.replace(landPhone, / /g, '')
        landPhone = _.replace(landPhone, '(', '')
        landPhone = _.replace(landPhone, ')', '')
        landPhone = _.replace(landPhone, '+', '')
        landPhone = _.replace(landPhone, /_/g, '')
        landPhone = _.replace(landPhone, '.', '')
        if (type !== 2) {
            landPhone = _.replace(landPhone, /-/g, '')
        }
        return landPhone
    },
    uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c /
                4).toString(16),
        )
    },
    objectToQueryString(params) {
        return (
            '?' +
            Object.keys(params)
                .map(key => key + '=' + params[key])
                .join('&')
        );
    },
    getPageName() {
        let page = window.location.pathname;
        page = page.replace(/\//g, '');
        return page;
    },
    addToLastLookedItem(item, type) {
        let list = localStorage.getItem(type === 1 ? "consumerLastLookedItems" : "pharmacyLastLookedItems");
        let myArray = list ? JSON.parse(list) : [];
        const existingIndex = myArray.findIndex(arrayItem => arrayItem.id === item.id);
        if (existingIndex !== -1) {
            myArray.splice(existingIndex, 1);
        }
        myArray.unshift(item);
        if (myArray.length > 3) {
            myArray.pop();
        }
        localStorage.setItem(type === 1 ? "consumerLastLookedItems" : "pharmacyLastLookedItems", JSON.stringify(myArray));
    },
    clearPhoneNumber(phone) {
        return phone.replace(/\(\+90\)|-/g, '');
    },
    scrollToClassName(className, offset = 20) {
        const element = document.querySelector(className);
        if (element) {
            const top = element.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({
                top: top,
                behavior: "smooth"
            });
        }
    },
    getCustomerTypeFromURL() {
        const host = window.location.hostname;

        if (host?.includes('orzaxb2b') || host?.includes('shiniqclubb2b-test.azurewebsites')) {
            return [4, 6]; // Eczane
        }

        if (host?.includes('orzaxclub') || host?.includes('shiniqclub-test.azurewebsites')) {
            return [3]; // Tüketici
        }

        // localhost / fallback
        return [4];
    },
    getErrorText(apiError, code) {
        const error = apiError?.data?.message;

        return error ? code + ' ' + error : "Beklenmeyen bir hata oluştu.";
    }
}

export default HelperGeneral;
